// supervisor-git-runner.ts
//
// Real `GitRunner` (commit-owner-git-ops.ts's injectable shape) backed by
// spawnAsyncCapture — the production implementation the supervisor wires
// into commit-owner.ts. Tests inject their OWN runner (argv-recording fake)
// per commit-owner.test.ts's pattern; this file exists so production code
// has exactly one place that constructs a real one instead of every call
// site rolling its own spawn wrapper.
import { spawnAsyncCapture } from "../spawn-async-capture-with-timeout.js";
import type { GitRunner } from "./commit-owner.js";

const GIT_TIMEOUT_MS = 30_000;

export const realGitRunner: GitRunner = async (args, cwd, options) => {
  const res = await spawnAsyncCapture("git", args, {
    cwd,
    timeoutMs: GIT_TIMEOUT_MS,
    forwardSigint: false,
    ...(options?.env ? { env: options.env } : {}),
  });
  return { status: res.status, stdout: res.stdout, stderr: res.stderr };
};
